import { App } from "./App";
require("./utils/layoutUtils");
require("./utils/CookiePolicy");
window.timeZoneString = "en-gb";
$(document).ready(function () {
    new App();
});
